const getElementBoundsInIframe = (liveElement) => {
  const iframeBounds = liveElement.ownerDocument.defaultView.frameElement.getBoundingClientRect();
  const { top, bottom, right, left, height, width, x, y } = liveElement.getBoundingClientRect();
  return {
    x,
    y,
    width,
    height,
    right,
    left,
    top: top + iframeBounds.top,
    bottom: bottom + iframeBounds.top,
  };
};

export default getElementBoundsInIframe;
